import PropTypes from 'prop-types';
import React from "react";
import ModalV4 from "../../../app/ui/modal/v4/v4";

import NoteFinder from 'core/gd-components/finder/note/note-finder';

export default class ModalEditorMentionsNotes extends ModalV4 {

    static propTypes = {
        params: PropTypes.shape({
            companyId: PropTypes.string,
            projectId: PropTypes.string,
            onSubmit: PropTypes.func
        })
    };

    onClickNote = (note) => {
        if (this.props.params.onSubmit) this.props.params.onSubmit({id: note.id, name: note.name, type: 'note', data:note})
    }

    render() {
        return (
            <div className="v4-container placement-middle" onClick={this.stopPropagation}>
                <NoteFinder companyId={this.props.params.companyId}
                            parentProjectId={this.props.params.projectId}
                            onClickNote={this.onClickNote}
                            onClose={this.closeModal}/>
            </div>
        );
    }
}